import { createSvgIcon } from '@material-ui/core';

export const EditIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 34.5007V42H13.4994L35.6159 19.8825L28.1165 12.3849L6 34.5007ZM41.4137 14.0843C41.7905 13.7014 42 13.1977 42 12.6745C42 12.1513 41.7905 11.6475 41.4137 11.2647L36.7341 6.58501C36.5546 6.40057 36.3366 6.25337 36.094 6.15268C35.8513 6.05199 35.5892 6 35.3242 6C35.0592 6 34.7971 6.05199 34.5545 6.15268C34.3118 6.25337 34.0938 6.40057 33.9143 6.58501L30.2554 10.2447L37.7548 17.744L41.4137 14.0843Z"
      fill="currentColor"
    />
  </svg>,
  'EditIcon',
);
